export default __webpack_public_path__ + "static/media/preflop-equity-handvshand_0002_thumb.ab44db6c.jpg";